import NotFound from '@pages/404'
import Home from '@pages/home'
import Privacy from '@pages/privacy'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

export function Routing() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  )
}
